import AppBar from "@/components/layout/AppBar";

export default function AppShell({ children }) {
  return (
    <div data-testid="app-shell" className="min-h-screen" style={{ backgroundColor: "#FAFAFA" }}>
      <AppBar />
      <main className="overflow-auto">{children}</main>
    </div>
  );
}
